module.exports = __webpack_public_path__ + "media/images/visualactive-b3bac737.png";